import { ModalContext } from 'components/ModalContext';
import { ShareModal } from 'components/Modals/ShareModal';
import { useCallback, useContext } from 'react';

export const useShare = () => {
  const { open } = useContext(ModalContext);
  return useCallback(() => {
    open(<ShareModal />);
  }, [open]);
};
